import { Component, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { MatSort, Sort } from '@angular/material/sort';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { TraineeListService } from "../../service/trainee-list.service";
import { RoleplayApiService } from "../../service/roleplay.service";
import { DateFormateService } from "../../date-formate.service";
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CreateSourceComponent } from "../create-source/create-source.component";
import { InteractionService } from '../../service/interaction/interaction.service';
import {PlatformRegionService} from '../../../app/service/shared/platform-region.service';

@Component({
    selector: 'app-veeva-vault-dashboard',
    templateUrl: './veeva-vault-dashboard.component.html',
    styleUrl: './veeva-vault-dashboard.component.scss',
    standalone: false
})
export class VeevaVaultDashboardComponent {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) private paginator: MatPaginator;
  showNoSearchResultsMessage: boolean = false;
  displayedColumns: string[] = ['sharepoint_path_id','source_path', 'product_name', 'created_date', 'updated_date', 'region', 'primary_market', 'product_group', 'is_internal', 'copy_approved'];
  filterValue: string;
  // dataSource:any= [];
  business_unit_code: string = sessionStorage.getItem('businessUnitCode');
 
  dataSource:any = new MatTableDataSource();
 
  constructor(public Router: Router, private _liveAnnouncer: LiveAnnouncer, public roleplayservice: RoleplayApiService,
    private dateFormatService: DateFormateService, public dialog: MatDialog, private PlatformRegionService: PlatformRegionService,
    private readonly intService: InteractionService) {
    this.intService.refreshHeader$.subscribe(() => {
      this.business_unit_code = sessionStorage.getItem('businessUnitCode')
    });
  }
  ngOnInit(){
    this.getDocumentList();
}

getDocumentList () {
  const region_name = this.PlatformRegionService.selectedRegion.name || '';
  this.roleplayservice.getDataSourceList(this.business_unit_code, region_name).subscribe(res => {
    res.forEach(item => {});
    res.sort((a, b) => b.sharepoint_path_id - a.sharepoint_path_id);
    this.dataSource = new MatTableDataSource(res);
    this.dataSource.paginator = this.paginator;
  });
}

convertUtcToLocal(utcDateString: string): Date | null {
  if (!utcDateString) return null;
  const utcDate = utcDateString.split('.')[0] + 'Z';
  return new Date(utcDate);
}
  userinfo(wwid: number) {
    this.Router.navigate(['/app-trainee-detail'], { skipLocationChange: true, queryParams: {id: wwid} });
  }
  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12; // Handle midnight
    const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
  
    // Format as "dd:mm:yyyy hh:mm tt"
    const formattedDate = `${this.padZero(date.getDate())}:${this.padZero(date.getMonth() + 1)}:${date.getFullYear()} ${formattedHours}:${formattedMinutes} ${ampm}`;
  
    return formattedDate;
  }
  createSource(){
    this.Router.navigate(['/app-create-source'], {skipLocationChange: true});
  }
  showDetails(row){
    this.Router.navigate(['/app-document-list'],{ queryParams: { 
      source_name: row.source_name,
      product_name:row.product_name,
      source_path: row.source_path,
      id: row.sharepoint_path_id 
    }, skipLocationChange: true});

  }
  
  // Function to pad zeros for single-digit day or month
  padZero(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }
  
  applyFilter(value: string) {
    this.filterValue = value.trim().toLowerCase();
    this.dataSource.filter = this.filterValue;
     // Check if there are any items after applying the filter
     if (this.dataSource.filteredData.length === 0 && this.filterValue !== '') {
      this.showNoSearchResultsMessage = true; // Set a flag to indicate no search results
    } else {
      this.showNoSearchResultsMessage = false; // Reset the flag
    }
  }
 
  openCreateSourceDialog() {
    const dialogRef = this.dialog.open(CreateSourceComponent, {
      width: '450px', // Specify the width of the dialog
      data: {} // You can pass data to the dialog if necessary
    });
  
    dialogRef.afterClosed().subscribe(result => {
      this.getDocumentList()
    });
  }
  docbutton(){
    this.Router.navigate(["/app-document-list"], { skipLocationChange: true });
  }
  sortData(sort: Sort) {
    if (sort.direction) {
      this._liveAnnouncer.announce(`Sorted ${sort.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }
 
}